export default __webpack_public_path__ + "static/media/Table saw SAWSTOP.85590468.png";